import {
  PublicationCommentStatus,
  type PublicationComment,
  type PublicationCommentType,
  type PublicationDatePlan,
  type PublicationDatePlanView,
} from '~/interfaces/publications';
import type { PublicationFormat } from '~/interfaces/publisher';
import type { Option } from '~/interfaces';
import { formatDate } from '~/common/functions';
import { publicationFormats } from '~/bin/publisher/place/new';

export const getTime = (dateString: string) => dateString.slice(0, 5);

export const getDay = (dateString: string) => formatDate(dateString).slice(0, 5);

export const getDatePlanView = (datePlan: PublicationDatePlan): PublicationDatePlanView => {
  const datePlanFromTimeLabel = getTime(datePlan.fromTime);
  const datePlanToTimeLabel = getTime(datePlan.toTime);

  return {
    datePlanFromLabel: getDay(datePlan.fromDate),
    datePlanToLabel: getDay(datePlan.toDate),
    datePlanFromTimeLabel,
    datePlanToTimeLabel,
    datePlanTime: `${datePlanFromTimeLabel} - ${datePlanToTimeLabel}`,
  };
};

export const getFormatName = (format: PublicationFormat) =>
  publicationFormats.find(({ value }: Option<PublicationFormat>) => value === format)?.name;

export const getNewComments = (
  { type, status }: PublicationComment,
  incomingType: PublicationCommentType,
) => type === incomingType && status !== PublicationCommentStatus.READ;

export const getDeclension = (count: number | string | null, title: string | string[]) => {
  const isArray = Array.isArray(title);
  if (count === null) return "";
  if (typeof count === "string") count = parseInt(count);
  if (count % 10 === 1 && count % 100 !== 11) {
    return isArray ? title[0] : ` ${title}`;
  }
  if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) {
    return isArray ? title[1] : ` ${title}а`;
  }
  return isArray ? title[2] : ` ${title}ов`;
};
